import styled from "styled-components";
import {Select, Input} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            min-width: 197px;
            font-size: 12px;
        }
    }
`;

export const Container = styled.div``;

export const RangePickerContainer = styled.div`
    margin-left: 8px;
`;

export const Title = styled.h2`
    margin: 15px 0%;
`;

export const SpinnerContainer = styled.div`
    justify:center,
    width: 100%,
    margin-top:16px,
    margin-left:16px
`;
export const InputContainer = styled(Input)`
    margin-left: 16px;
`;
